import { TableFiltersOptions } from '../Table.types';
import TableDateFilter from '../TableDateFilter';
import HeaderFilterCheckbox from './HeaderFilterCheckbox';

import styles from './TableHeaderFilters.module.css';

const TableHeaderFilters: React.FC<TableFiltersOptions> = ({ date, checkboxes }) => {
  const haveEnableFilters = date || checkboxes?.length;

  if (!haveEnableFilters) {
    return null;
  }

  return (
    <div className={styles.container}>
      {!!date && <TableDateFilter />}
      {checkboxes?.map((checkboxItem) => (
        <HeaderFilterCheckbox
          key={`${checkboxItem.filterKey}-${checkboxItem.label}`}
          filterKey={checkboxItem.filterKey}
          label={checkboxItem.label}
        />
      ))}
    </div>
  );
};

export default TableHeaderFilters;
